import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpEvent, HttpRequest, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { CookieService } from 'ngx-cookie-service';

@Injectable({
    providedIn: 'root'
})
export class DataService {
    constructor(private httpClient: HttpClient, private cookieService: CookieService) { }

    //get webpage grid
    public getWebPageGrid(webpageid: number, callback: any) {
        if (window.localStorage) {
            var storageKey: string = localStorage.getItem("cachestring") + "_webpagegrid_" + webpageid;

            if (!localStorage.getItem(storageKey)) {
                this.httpClient.get(encodeURI("/jsondatawebpagegrid.ashx?webpageid=" + webpageid), {
                    headers: new HttpHeaders({
                        'X-TOKEN': this.cookieService.get('X-TOKEN')
                    })
                }).subscribe((data) => {
                    if (data) {
                        localStorage.setItem(storageKey, JSON.stringify(data));

                        var jsondata = JSON.parse(localStorage.getItem(storageKey));
                        callback(jsondata);
                    }
                });
            }
            else {
                var jsondata = JSON.parse(localStorage.getItem(storageKey));
                callback(jsondata);
            }
        }
        else {
            this.httpClient.get(encodeURI("/jsondatawebpagegrid.ashx?webpageid=" + webpageid), {
                headers: new HttpHeaders({
                    'X-TOKEN': this.cookieService.get('X-TOKEN')
                })
            }).subscribe((data) => {
                callback(data);
            });
        }
    }

    //get webpage grid call
    public getWebPageGridTestCall(): Observable<any> {
        return this.httpClient.get(encodeURI("/jsondatawebpagegrid.ashx?webpageid=1"), {
            headers: new HttpHeaders({
                'X-TOKEN': this.cookieService.get('X-TOKEN')
            })
        });
    }

    //get element data
    public getElementData(webpagedefinitionitemid: number, docid: number, webpagelayoutitemid: number, webpagethemeelementid: number, cache: boolean, elementcultureuri: string, callback: any, otherparams: string) {
        if (window.localStorage && cache == true) {
            var storageKey: string = localStorage.getItem("cachestring") + "_webpageelementdata_" + webpagedefinitionitemid;

            if (!localStorage.getItem(storageKey)) {
                this.httpClient.get(encodeURI("/jsondataelement.ashx?webpagedefinitionitemid=" + webpagedefinitionitemid + "&docid=" + docid + "&webpagelayoutitemid=" + webpagelayoutitemid + "&webpagethemeelementid=" + webpagethemeelementid + "&cache=" + cache + "&elementcultureuri=" + elementcultureuri + "&" + otherparams),
                    {
                        headers: new HttpHeaders({ 'X-TOKEN': this.cookieService.get('X-TOKEN') })
                    }).subscribe((data) => {
                    if (data) {
                        localStorage.setItem(storageKey, JSON.stringify(data));

                        var jsondata = JSON.parse(localStorage.getItem(storageKey));
                        callback(jsondata);
                    }
                });
            }
            else {
                var jsondata = JSON.parse(localStorage.getItem(storageKey));
                callback(jsondata);
            }
        }
        else {
            this.httpClient.get(encodeURI("/jsondataelement.ashx?webpagedefinitionitemid=" + webpagedefinitionitemid + "&docid=" + docid + "&webpagelayoutitemid=" + webpagelayoutitemid + "&webpagethemeelementid=" + webpagethemeelementid + "&cache=" + cache + "&elementcultureuri=" + elementcultureuri + "&" + otherparams), {
                headers: new HttpHeaders({
                    'X-TOKEN': this.cookieService.get('X-TOKEN')
                })
            }).subscribe((data) => {
                callback(data);
            });
        }
    }

    //set element data
    public setElementData(webpagedefinitionitemid: number, method: string, json: string, rcresponse: string): Observable<any> {
        var formData = new FormData();

        //add post data
        formData.append("json", json);
        if (rcresponse !== '') formData.append("rcresponse", rcresponse);

        return this.httpClient.post(
            encodeURI(encodeURI("/jsondataelementset.ashx?webpagedefinitionitemid=" + webpagedefinitionitemid + "&m=" + method)),
            formData,
            {
                headers: new HttpHeaders({ 'X-TOKEN': this.cookieService.get('X-TOKEN') })
            }
        );

    }

    //set element data post
    public setElementDataPost(webpagedefinitionitemid: number, method: string, json: string, json2: string, formData, rcresponse: string): Observable<any> {
        if (!formData)
            formData = new FormData();

        if (formData) {
            formData.delete("json");
            formData.delete("json2");

            //add post data
            formData.append("json", json);
            formData.append("json2", json2);

            if (rcresponse !== '') {
                formData.delete("rcresponse");
                formData.append("rcresponse", rcresponse);
            }
        }


        return this.httpClient.post(
            encodeURI("/jsondataelementset.ashx?webpagedefinitionitemid=" + webpagedefinitionitemid + "&m=" + method),
            formData,
            {
                headers: new HttpHeaders({ 'X-TOKEN': this.cookieService.get('X-TOKEN') })
            }
        );
    }

    //get culture valuestring
    public getSLLValueString(culture, paramuri: string, defaultvalue: string) {
        if (culture != undefined && culture.length > 0) {
            if (culture.find(x => x.uri == paramuri) != undefined) {
                return culture.find(x => x.uri == paramuri).valuestring;
            }
            else {
                this.httpClient.get(encodeURI("/jsoncultureset.ashx?uri=" + paramuri + "&valuestring=" + defaultvalue), { headers: new HttpHeaders({ 'X-TOKEN': this.cookieService.get('X-TOKEN') }) }).subscribe((data) => {
                    culture.push({ uri: paramuri, valuestring: defaultvalue });
                });

                return defaultvalue;
            }
        }
        else {
            return defaultvalue;
        }
    }

    //get month name
    getMonthName(elementcultureuri, month, culture) {
        var returnvalue = '';

        switch (month) {
            case 1: {
                returnvalue = this.getSLLValueString(culture, elementcultureuri + '/january', 'januar');
                break;
            }
            case 2: {
                returnvalue = this.getSLLValueString(culture, elementcultureuri + '/february', 'februar');
                break;
            }
            case 3: {
                returnvalue = this.getSLLValueString(culture, elementcultureuri + '/march', 'marec');
                break;
            }
            case 4: {
                returnvalue = this.getSLLValueString(culture, elementcultureuri + '/april', 'april');
                break;
            }
            case 5: {
                returnvalue = this.getSLLValueString(culture, elementcultureuri + '/may', 'maj');
                break;
            }
            case 6: {
                returnvalue = this.getSLLValueString(culture, elementcultureuri + '/june', 'junij');
                break;
            }
            case 7: {
                returnvalue = this.getSLLValueString(culture, elementcultureuri + '/july', 'julij');
                break;
            }
            case 8: {
                returnvalue = this.getSLLValueString(culture, elementcultureuri + '/august', 'avgust');
                break;
            }
            case 9: {
                returnvalue = this.getSLLValueString(culture, elementcultureuri + '/september', 'september');
                break;
            }
            case 10: {
                returnvalue = this.getSLLValueString(culture, elementcultureuri + '/october', 'oktober');
                break;
            }
            case 11: {
                returnvalue = this.getSLLValueString(culture, elementcultureuri + '/november', 'november');
                break;
            }
            case 12: {
                returnvalue = this.getSLLValueString(culture, elementcultureuri + '/december', 'december');
                break;
            }
        }

        //return
        return returnvalue;
    }

    //get weekday name
    getWeekDayName(elementcultureuri, day, culture) {
        var returnvalue = '';

        switch (day) {
            case 1: {
                returnvalue = this.getSLLValueString(culture, elementcultureuri + '/1', 'Ponedeljek');
                break;
            }
            case 2: {
                returnvalue = this.getSLLValueString(culture, elementcultureuri + '/2', 'Torek');
                break;
            }
            case 3: {
                returnvalue = this.getSLLValueString(culture, elementcultureuri + '/3', 'Sreda');
                break;
            }
            case 4: {
                returnvalue = this.getSLLValueString(culture, elementcultureuri + '/4', 'Četrtek');
                break;
            }
            case 5: {
                returnvalue = this.getSLLValueString(culture, elementcultureuri + '/5', 'Petek');
                break;
            }
            case 6: {
                returnvalue = this.getSLLValueString(culture, elementcultureuri + '/6', 'Sobota');
                break;
            }
            case 7: {
                returnvalue = this.getSLLValueString(culture, elementcultureuri + '/7', 'Nedelja');
                break;
            }

        }


        //return
        return returnvalue;
    }

}




